<template>
  <div id="shipping-list">
    <div v-if="isLoading" class="shipping-preview">
      <!-- Loading shippings... -->
    </div>
    <div v-else>
      <b-card class="bg-dargk tegxt-light" v-if="type !== 'search'">
        <b-row>
          <b-col class="col-6">
            <h4 v-translate>Quick Search</h4>
            <b-alert show variant="info" class="p-1 px-2">
              <p class="m-0"><small><translate>This list shows the results for the last 30 days. Shall you need anything out of this date range, please use the Advanced Search</translate> <a href="/search" target="_blank"><font-awesome-icon icon="external-link-alt" /></a></small></p>
            </b-alert>
            <b-form @submit.prevent="quickSearch">
              <label class="mr-2" for="inline-form-input-name" v-translate>Quick Search Term</label>
              <b-input-group>
                <b-input
                  id="inline-form-input-name"
                  class="mb-2"
                  :placeholder="searchPlaceholder"
                    v-model="quickSearchTerm"
                ></b-input>
                <b-input-group-append>
                  <b-button class="mb-2 py-0" type="submit" size="sm" variant="primary" v-translate>Search</b-button>
                </b-input-group-append>
              </b-input-group>
              <div class="text-rigsht">
                <a href="#" class="" @click.prevent="clearSearch" v-translate>Clear search</a>
              </div>
            </b-form>
          </b-col>
          <b-col v-if="!isSelfService && storesSelect.length > 0">
            <h4 v-translate>Filter by stores</h4>
            <b-row>
              <b-col>
                <label class="mr-2" for="inline-form-select-from" v-translate>From</label>
                <b-form-select v-model="restrictToStoreFrom" :options="storesSelect" class="mb-3 form-control" @change="if ($refs.paginator) $refs.paginator.changePage(1); resetShippings(); resetPagination(); fetchShippings();">
                  <template slot="first">
                    <option :value="null" v-translate>All stores</option>
                  </template>
                </b-form-select>
              </b-col>
              <b-col>
                <label class="mr-2" for="inline-form-select-to" v-translate>To</label>
                <b-form-select v-model="restrictToStoreTo" :options="storesSelect" class="mb-3 form-control" @change="if ($refs.paginator) $refs.paginator.changePage(1); resetShippings(); resetPagination(); fetchShippings();">
                  <template slot="first">
                    <option :value="null" v-translate>All stores</option>
                  </template>
                </b-form-select>
              </b-col>
            </b-row>

          </b-col>
        </b-row>
        <b-row v-if="type === 'drafts' && !isSelfService">
          <b-col>
            <hr>
            <b-form-group>
              <label v-translate>View:</label>
              <b-form-radio-group v-model="shippingType" :options="shippingTypeOptions"></b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>
      <b-card class="bg-dargk tegxt-light" v-if="type === 'search'">
        <h4><translate>Advanced Search</translate></h4>
        <b-form @submit.prevent="advancedSearch">
          <b-form-row>
            <b-col md="6">
              <label class="sr-onsly mr-2" for="inline-form-input-name" v-translate>Search Term</label>
              <b-input
                id="inline-form-input-name"
                class="mb-2 col-12"
                :placeholder="advancedSearchPlaceholder"
                v-model="advancedSearchTerm"
              ></b-input>

              <label class="" for="inline-form-input-name" v-translate>Select Date Range (90 days max.)</label> <label v-show="dateRangeActive === true">&nbsp;[<a href="#" @click.prevent="resetDateRange" v-translate>reset range</a>]</label>
              <date-range-picker
                v-if="this.locale.daysOfWeek"
                v-model="dateRange"
                @update="onDateRangeUpdate"
                :locale-data="{...locale}"
                :opens="opens"
                class="mb-2 w-100"
                :ranges="ranges"
                :date-format="disableOutOfRangeDates"
                @start-selection="setMinDate"
                @select="minDate = null"
                @toggle="minDate = null"
              >
                <div slot="input" slot-scope="picker" style="top: 3px;position:relative">
                  <font-awesome-icon :icon="['far', 'calendar-alt']" size="1x" style="vertical-align: middle" />
                  <span v-if="!dateRangeActive" style="vertical-align: middle">...</span>
                  <span v-else style="vertical-align: middle">{{moment(dateRange.startDate).format('L')}} - {{moment(dateRange.endDate).format('L')}}</span>
                </div>
              </date-range-picker>

            </b-col>
            <b-col md="6">
              <label for="shipping-status" class="sr-onsly mr-2" v-if="!isSelfService && (pickupShippingTypeId || returnShippingTypeId)" v-translate>Shipping Types</label>
              <b-form-checkbox-group id="shipping-type" v-model="advancedSearchType" v-if="!isSelfService">
                <b-form-checkbox v-if="pickupShippingTypeId" :value="pickupShippingTypeId" class="col-5"><translate>Pickup shipping type</translate></b-form-checkbox>
                <b-form-checkbox v-if="returnShippingTypeId" :value="returnShippingTypeId" class="col-5"><translate>Return shipping type</translate></b-form-checkbox>
              </b-form-checkbox-group>
              <label for="shipping-status" class="sr-onsly mr-2" v-translate>Shipping Status</label>
              <b-form-checkbox-group id="shipping-status" v-model="advancedSearchStatus">
                <b-form-checkbox value="DRAFT" class="col-5"><translate>Received by the system</translate></b-form-checkbox>
                <b-form-checkbox value="READY" class="col-5"><translate>Ready to be scheduled</translate></b-form-checkbox>
                <b-form-checkbox value="WAITING" class="col-5"><span v-translate="{courierI18n: this.courierI18n}">Searching for %{courierI18n}</span></b-form-checkbox>
                <b-form-checkbox value="CONFIRMED" class="col-5"><span v-translate="{courierI18n: this.courierI18n}">%{courierI18n} in transit to origin</span></b-form-checkbox>
                <b-form-checkbox value="INTRANSIT" class="col-5"><span v-translate="{courierI18n: this.courierI18n}">%{courierI18n} in transit to destination</span></b-form-checkbox>
                <b-form-checkbox value="DELIVERED" class="col-5"><translate>Shipping delivered</translate></b-form-checkbox>
                <b-form-checkbox value="INCIDENCE" class="col-5"><translate>On incidence</translate></b-form-checkbox>
                <b-form-checkbox value="TOBERETURNED" class="col-5"><translate>To be returned to sender</translate></b-form-checkbox>
                <b-form-checkbox value="CANCELED" class="col-5"><translate>Canceled</translate></b-form-checkbox>
                <b-form-checkbox value="RETURNED" class="col-5"><translate>Returned to sender</translate></b-form-checkbox>
              </b-form-checkbox-group>
            </b-col>
          </b-form-row>
          <b-form-row class="align-middle">
            <b-button type="submit" variant="primary" :disabled="outOfDateRange" v-translate>Search</b-button>
            <font-awesome-icon v-if="outOfDateRange" class="text-warning align-self-center ml-2" icon="exclamation-triangle" v-b-tooltip.hover :title="$gettext('The selected date range is too wide. Please select a range of 90 days or less to search.')" />
            <b-button variant="link" @click.prevent="clearAdvanceSearch" v-translate>Clear search</b-button>
          </b-form-row>
          <b-alert show variant="warning" class="p-1 px-2 mt-2 mb-0" v-if="restoredRangeBlocked && outOfDateRange">
            <p class="m-0"><small><translate>The selected date range is too wide. Please select a range of 90 days or less to search.</translate></small></p>
          </b-alert>

        </b-form>
      </b-card>
      <b-row class="mb-3">
        <b-col class="align-self-center">
          <h3 v-show="quickSearchTerm && isSearch" v-translate="{quickSearchTerm: quickSearchTerm}">Search results for: %{quickSearchTerm}</h3>
          <h3 v-show="!quickSearchTerm && isSearch" v-translate>Search results</h3>
        </b-col>
        <b-col v-if="!quickSearchTerm && isSearch" class="text-right">
          <div class="w-auto d-inline-block text-center align-self-center">
            <b-form-checkbox class="save-from my-1"
              v-model="simplifiedReport"
              :value="1"
              :unchecked-value="0"
              plain>
              <span v-translate>Complete</span> <span class="switch monochrome"><span class="slider round"></span></span> <span v-translate>Simplified</span>
            </b-form-checkbox>
            <b-form-checkbox class="save-from my-1"
              :class="simplifiedReport ? 'text-muted' : ''"
              v-model="allStatuses"
              :value="true"
              :unchecked-value="false"
              plain
              :disabled="simplifiedReport === 1"
              >
              <span v-translate>Last status</span> <span class="switch monochrome"><span class="slider round"></span></span> <span v-translate>All statuses</span>
            </b-form-checkbox>
          </div>
          <div class="w-auto d-inline-block text-center align-self-center">
            <b-button class="mb-4 ml-3" size="sm" @click.prevent="downloadCsv" :disabled="!this.dateRangeActive || this.shippings.length === 0 || outOfDateRange" :title="!this.dateRangeActive ? $gettext('You must select a date range to export') : (outOfDateRange ? $gettext('The selected date range is too wide. Please select a range of 90 days or less to export.') : (this.shippings.length === 0 ? $gettext('There are no results to export') : $gettext('Export and download search results as CSV file')))">
              <font-awesome-icon icon="download" size="1x" />&nbsp;&nbsp;
              <translate>Export as CSV</translate>
            </b-button>
            <font-awesome-icon v-if="outOfDateRange" class="text-warning align-self-center" icon="exclamation-triangle" v-b-tooltip.hover :title="$gettext('The selected date range is too wide. Please select a range of 90 days or less to export.')" />
          </div>
        </b-col>
      </b-row>

      <b-row v-if="type === 'drafts' || type === 'ready'">
        <b-col cols="6" class="mb-3 text-left">
          <b-button :variant="labelableShippings.length === 0 && shippings.length > 0 ? 'warning' : 'primary'" :disabled="labelableShippings.length === 0 || generatingLabels" @click.prevent="bulkExportLabels" :title="labelButtonTitle">
            <b-spinner small v-if="generatingLabels"></b-spinner>
            <font-awesome-icon icon="file-pdf" size="1x" />&nbsp;&nbsp;<span v-translate="{labelableShippings: labelableShippings.length}">Export %{labelableShippings} PDF labels from this listing page</span>
          </b-button>
        </b-col>
        <b-col cols="6" class="mb-3 text-right">
          <advanced-label-export-form />
        </b-col>
      </b-row>

      <b-row v-if="type === 'drafts'">
        <b-col cols="6" class="mb-3 text-left">
          <b-button size="sm" style="padding: .15rem 1rem;" variant="outline-success" :disabled="shippings.length === 0 || shippingsEnabledToReady.length === 0" @click.prevent="bulkChangeStatusToReady">
            <span v-translate="{shippingsEnabledToReady: shippingsEnabledToReady.length}">Change %{shippingsEnabledToReady} shippings to ready</span>
          </b-button>
        </b-col>
      </b-row>

      <div v-if="!shippings || shippings.length === 0" class="shipping-preview" v-translate>
        No shippings are here... yet.
      </div>
      <shipping-preview v-for="(shipping, index) in shippings" :shipping="shipping" :shipping-types="shippingTypes" :key="index" />
      <paginator v-if="totalPages" :currentQuery="currentQuery" :totalPages="totalPages" :currentPage.sync="currentPage" ref="paginator" />
    </div>

    <spinner />

    <b-modal id="modalFixAddressFrom" ref="modalFixAddressFrom" :hide-footer="true" @shown="clearInterval" @hide="setInterval">
      <div slot="modal-title" v-translate>Review FROM Address</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <fix-addresses-form :theShipping="shippingEdit" type="from" @success="closeModal('modalFixAddressFrom')" @cancel="closeModal('modalFixAddressFrom')" />
    </b-modal>

    <b-modal id="modalFixAddressTo" ref="modalFixAddressTo" :hide-footer="true" @shown="clearInterval" @hide="setInterval">
      <div slot="modal-title" v-translate>Review TO Address</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <fix-addresses-form :theShipping="shippingEdit" type="to" @success="closeModal('modalFixAddressTo')" @cancel="closeModal('modalFixAddressTo')" />
    </b-modal>

    <b-modal size="lg" id="modalPickedupShippings" ref="modalPickedupShippings" :hide-footer="true" @hide="pickedupShippingsParent = {}; pickedupShippings = [];">
      <div slot="modal-title" v-translate>Picked Up Shippings</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <picked-up-list :pickupShipping="pickedupShippingsParent" :shippings="pickedupShippings" />
    </b-modal>

    <div class="d-none">
      <translate>You must select a date range to export</translate>
      <translate>There are no results to export</translate>
      <translate>Export and download search results as CSV file</translate>
      <translate>There are no picked up shippings to show yet</translate>
    </div>
  </div>
</template>
<script>
import AddressMixins from '@/mixins/address.mixin.js'
import { mapGetters } from 'vuex'
import ShippingPreview from '@/components/ShippingPreview'
import Paginator from '@/components/Paginator'
import { FETCH_SHIPPINGS, RESET_SHIPPINGS } from '@/store/actions.type'
import Spinner from '@/components/Spinner'
import DateRangePicker from 'vue2-daterange-picker'
import AddressAutocomplete from '@/components/AddressAutocomplete'
import AdvancedLabelExportForm from '@/components/AdvancedLabelExportForm'
import PlacePicker from '@/components/PlacePicker'
import PickedUpList from '@/components/PickedUpList'
import FixAddressesForm from '@/components/FixAddressesForm'

export default {
  name: 'ShippingList',
  title() {
    let title
    switch (this.$options.propsData.type) {
      case 'ongoing':
        title = this.$gettext('Ongoing Shippings')
        break
      case 'scheduled':
        title = this.$gettext('Scheduled Shippings')
        break
      case 'history':
        title = this.$gettext('Shippings History')
        break
      case 'incidences':
        title = this.$gettext('Shippings With Incidences')
        break
      case 'search':
        title = this.$gettext('Search')
        break
      case 'ready':
        title = this.$gettext('Ready to be scheduled')
        break
      case 'toreview':
        title = this.$gettext('To be reviewed')
        break
      case 'drafts':
        title = this.$gettext('Received by the system')
        break
    }
    return title
  },
  components: {
    ShippingPreview,
    Paginator,
    Spinner,
    DateRangePicker,
    AddressAutocomplete,
    AdvancedLabelExportForm,
    PlacePicker,
    PickedUpList,
    FixAddressesForm
  },
  props: {
    type: {
      type: String,
      required: false,
      default: 'all'
    },
    itemsPerPage: {
      type: Number,
      required: false,
      default: 30
    }
  },
  data() {
    return {
      currentQuery: {},
      currentPage: 1,
      updating: false,
      searchFilters: {},
      quickSearchTerm: '',
      isSearch: false,
      newSearch: true,
      searchPlaceholder: this.$gettext('Shipping ID or destination contact'),
      advancedSearchPlaceholder: this.$gettext('Shipping ID, internal code or internal order'),
      advancedSearchFilters: [],
      advancedSearchTerm: '',
      advancedSearchType: [],
      pickupShippingTypeId: null,
      returnShippingTypeId: null,
      advancedSearchStatus: [],
      advancedSearchDateRange: {},
      advancedSearchFrom: null,
      dateRange: { // used for v-model prop
        startDate: this.moment().toDate(),
        endDate: this.moment().toDate()
      },
      dateRangeActive: false,
      // Set only by init() when it refuses the initial fetch of a q whose date range
      // busts the cap. It drives the alert that explains the empty screen and gates
      // the currentPage watcher, so it MUST be cleared wherever a search is applied
      // or cleared — leaving it set would keep pagination dead for the session.
      restoredRangeBlocked: false,
      // Date range cap in ELAPSED days, measured from startOf('day') of the start to
      // endOf('day') of the end. It mirrors core-api's REPORT_MAX_RANGE_DAYS
      // (config/app.php), which rejects CSV reports with a 422 when
      // date_diff(from, to)->days exceeds it, so it carries no slack: 91 calendar
      // days (90 elapsed) pass, 92 are blocked, exactly as the API does. Even the
      // longest preset ("Last 90 days", 89 elapsed) fits inside it. It feeds both the
      // calendar's maxDate and the outOfDateRange guard, so both share one boundary.
      maxElapsedRangeDays: 90,
      opens: 'right', //  which way the picker opens, default "center", can be "left"/"right"
      locale: {},
      ranges: { //  default value for ranges object (if you set this to false ranges will no be rendered)
        [this.$gettext('Today')]: [this.moment().toDate(), this.moment().toDate()],
        [this.$gettext('Yesterday')]: [this.moment().subtract(1, 'days').toDate(), this.moment().subtract(1, 'days').toDate()],
        [this.$gettext('Last 7 days')]: [this.moment().subtract(6, 'day').startOf('day').toDate(), this.moment().subtract(0, 'day').endOf('day').toDate()],
        [this.$gettext('Last 30 days')]: [this.moment().subtract(29, 'day').startOf('day').toDate(), this.moment().subtract(0, 'day').endOf('day').toDate()],
        [this.$gettext('Last 60 days')]: [this.moment().subtract(59, 'day').startOf('day').toDate(), this.moment().subtract(0, 'day').endOf('day').toDate()],
        [this.$gettext('Last 90 days')]: [this.moment().subtract(89, 'day').startOf('day').toDate(), this.moment().subtract(0, 'day').endOf('day').toDate()],
        [this.$gettext('This month')]: [this.moment().startOf('month').toDate(), this.moment().endOf('month').toDate()],
        [this.$gettext('Last week')]: [this.moment().subtract(1, 'week').startOf('week').toDate(), this.moment().subtract(1, 'week').endOf('week').toDate()],
        [this.$gettext('Last month')]: [this.moment().subtract(1, 'month').startOf('month').toDate(), this.moment().subtract(1, 'month').endOf('month').toDate()]
      },
      // Start day of the selection in progress, i.e. between the first and second
      // click. Cleared as soon as it completes (@select, also fired by the presets) and
      // whenever the picker opens or closes, so an applied range never keeps the
      // calendar restricted.
      minDate: null,
      datepickerLocalized: false,
      interval: null,
      shippingEdit: {},
      fromAddress: null,
      toAddress: null,
      validFrom: false,
      validTo: false,
      generatingLabels: false,
      restrictToStoreFrom: null,
      restrictToStoreTo: null,
      simplifiedReport: 1,
      allStatuses: false,
      pickedupShippingsParent: {},
      pickedupShippings: [],
      shippingType: null,
      shippingTypeOptions: [
        {
          text: this.$pgettext('masc', 'All'),
          value: null
        },
        {
          text: this.$gettext('Next Day'),
          value: 'next_day'
        },
        {
          text: this.$gettext('Same Day'),
          value: 'same_day'
        }
      ]
    }
  },
  computed: {
    maxDate() {
      // Last selectable instant of the selection in progress, in local time, so
      // start + 90 stays selectable in every timezone. Only disableOutOfRangeDates
      // reads it: do NOT bind it to the picker's :maxDate, whose clickRange() would
      // clamp the presets again.
      return this.minDate ? this.moment(this.minDate).add(this.maxElapsedRangeDays, 'days').endOf('day').toDate() : null
    },
    outOfDateRange() {
      // The calendar does block out-of-range cells (they get pointer-events: none),
      // but only once a start date is picked. Presets applied without one, ranges
      // restored from a ?q= link and timezone edge cases never go through it, so
      // this is the guard that actually keeps oversized searches and CSV reports
      // from reaching the API.
      return this.moment(this.dateRange.endDate).diff(this.moment(this.dateRange.startDate), 'days') > this.maxElapsedRangeDays
    },
    listConfig() {
      const { type } = this
      const filters = {
        includes: ['status_history.shippingStatusReason', 'items', 'courier.courier_available.vehicle', 'courier.courier_available.user'],
        page: this.currentPage - 1,
        limit: this.itemsPerPage,
        sort: [{
          key: this.type !== 'search' ? 'updated_at' : 'created_at',
          direction: 'desc'
        }]
      }
      filters.filter_groups = []
      if (this.type !== 'search') {
        if (this.type === 'ongoing') {
          filters.filter_groups = [{
            filters: [{
              key: 'status',
              value: ['CONFIRMED', 'TOBERETURNED', 'INTRANSIT', 'WAITING', 'ATPICKUPPOINT'],
              operator: 'in'
            }]
          }]
        }
        if (this.type === 'history') {
          filters.filter_groups = [{
            filters: [{
              key: 'status',
              value: ['DELIVERED', 'RETURNED', 'CANCELED'],
              operator: 'in'
            }]
          }]
        }
        if (this.type === 'scheduled') {
          filters.filter_groups = [{
            filters: [{
              key: 'status',
              value: 'WAITING',
              operator: 'eq'
            },
            {
              key: 'scheduled_date',
              value: this.moment().utc().format('YYYY-MM-DD HH:mm:ss'),
              operator: 'gt'
            }]
          }]
        }
        if (this.type === 'drafts') {
          filters.filter_groups = [{
            filters: [{
              key: 'status',
              value: ['DRAFT', 'READYATSTORE'],
              operator: 'in'
            }]
          }]
          if (this.shippingType === 'next_day') {
            filters.filter_groups[1] = {
              filters: [
                ['shipping_type_id', 'eq', this.shippingTypes.find(x => x.name === 'next_day').id]
              ]
            }
          } else if (this.shippingType === 'same_day') {
            filters.filter_groups[1] = {
              filters: [
                ['shipping_type_id', 'eq', this.shippingTypes.find(x => x.name === 'next_day').id, 'true']
              ]
            }
          }
        }
        if (this.type === 'ready') {
          filters.filter_groups = [{
            filters: [{
              key: 'status',
              value: 'READY',
              operator: 'eq'
            }]
          }]
        }
        if (this.type === 'incidences') {
          filters.filter_groups = [{
            filters: [{
              key: 'status',
              value: 'INCIDENCE',
              operator: 'eq'
            }]
          }]
        }
        if (this.type === 'toreview') {
          filters.filter_groups = [{
            filters: [{
              key: 'fields_revision',
              value: 1,
              operator: 'eq'
            },
            {
              key: 'status',
              value: ['DRAFT', 'READY', 'WAITING'],
              operator: 'in'
            }]
          }]
        }

        if (this.restrictToStoreFrom) {
          filters.filter_groups.push({
            filters: [
              ['from_place_id', 'eq', this.restrictToStoreFrom]
            ]
          })
        }
        if (this.restrictToStoreTo) {
          filters.filter_groups.push({
            filters: [
              ['to_place_id', 'eq', this.restrictToStoreTo]
            ]
          })
        }

        if (this.searchFilters) {
          filters.filter_groups.push(this.searchFilters)
        }

        filters.filter_groups.push({
          filters: [
            ['updated_at', 'bt', [this.moment().subtract(29, 'days').tz(this.$tz).startOf('day').utc().format('YYYY-MM-DD HH:mm:ss'), this.moment().tz(this.$tz).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss')]]
          ]
        })
      } else {
        filters.filter_groups = this.advancedSearchFilters
      }
      const infiniteScroll = this.$appConfig.infiniteScroll || false

      return {
        type,
        filters,
        infiniteScroll,
        updating: this.updating
      }
    },
    storesSelect() {
      return this.$store.getters.profile.company.stores ? this.$store.getters.profile.company.stores.map(x => { return { text: x.reference, value: x.place_id } }) : []
    },
    pages() {
      if (this.isLoading || this.shippingsCount <= this.itemsPerPage) {
        return []
      }
      return [...Array(Math.ceil(this.shippingsCount / this.itemsPerPage)).keys()].map(e => e + 1)
    },
    totalPages() {
      return Math.ceil(this.shippingsCount / this.itemsPerPage)
    },
    labelableShippings() {
      return this.shippings.filter(x => (
        x.status === 'DRAFT' ||
        x.status === 'READYATSTORE' ||
        x.status === 'READY' ||
        x.status === 'WAITING' ||
        x.status === 'CONFIRMED' ||
        x.status === 'ATPICKUPPOINT'
      ) && (
        !x.fields_revision ||
        (
          this.$store.getters.profile.company.settings.findIndex(x => x.name === 'label_wrong_address') !== -1 &&
          this.$store.getters.profile.company.settings.find(x => x.name === 'label_wrong_address').pivot.value === '1'
        )
      )).map(x => x.id)
    },
    shippingsEnabledToReady() {
      return this.shippings.filter(x => x.status === 'DRAFT' && !x.fields_revision).map(x => x.id)
    },
    labelButtonTitle() {
      if (this.shippings.length > 0 && this.labelableShippings.length === 0) {
        return this.$gettext('All the shippings in this page need addresses revision before to be able to print their labels')
      } else if (this.shippings.length > 0 && this.labelableShippings.length !== 0 && this.labelableShippings.length < this.shippings.length) {
        return this.$gettext('Some shippings in this page need addresses revision before to be able to print their labels')
      } else {
        return this.$gettext('Opens in a new window')
      }
    },
    ...mapGetters([
      'shippingsCount',
      'isLoading',
      'shippings'
    ])
  },
  watch: {
    simplifiedReport(val) {
      if (val) {
        this.allStatuses = false
      }
    },
    // currentQuery(newValue) {
    //   this.$nextTick(() => {
    //     this.$refs.paginator.prevQuery = newValue
    //   })
    // },
    currentPage(newValue) {
      console.log(newValue)
      // listConfig carries the search's own date filter, so paging would re-query the
      // very range init() just refused. Keyed on restoredRangeBlocked and NOT on
      // outOfDateRange: that computed tracks what the picker shows, not the applied
      // search, and the two diverge — picking an oversized range on top of results
      // from a valid search leaves those results (and their pages) perfectly legal.
      if (this.restoredRangeBlocked) return
      this.listConfig.filters.offset = (newValue - 1) * this.itemsPerPage
      this.listConfig.filters.page = (newValue - 1)
      this.fetchShippings(this.listConfig)
    },
    type(val, oldVal) {
      clearTimeout(this.interval)
      this.currentQuery = {}
      this.advancedSearchFilters = {}
      this.clearSearch()
      this.resetPagination()
      this.init()
    },
    shippingType(val) {
      this.resetPagination()
      this.$nextTick(() => {
        this.fetchShippings(this.listConfig)
      })
    },
    quickSearchTerm(val, oldVal) {
      if (val) {
        clearTimeout(this.interval)
        this.clearInterval()
      } else if (val === '' || !val) {
        this.setInterval()
      }
    }
  },
  mixins: [AddressMixins],
  created() {
    const moment = this.$frontConfig.i18n.moment || 'en'
    this.moment.locale(moment)
    this.fetchShippingSizes()
    this.fetchShippingTypes()
      .then(() => {
        this.pickupShippingTypeId = this.shippingTypes.findIndex(x => x.name === 'pickup') !== -1 ? this.shippingTypes.find(x => x.name === 'pickup').id : null
        this.returnShippingTypeId = this.shippingTypes.findIndex(x => x.name === 'return') !== -1 ? this.shippingTypes.find(x => x.name === 'return').id : null
      })
  },
  mounted() {
    this.init()
  },
  beforeDestroy() {
    clearTimeout(this.interval)
  },
  methods: {
    setMinDate(e) {
      this.minDate = this.moment(e).format('YYYY-MM-DD')
    },
    onDateRangeUpdate() {
      this.dateRangeActive = true
      // The picker fires @update as soon as a range is confirmed, so an oversized
      // range would search on its own without ever going through the Search button.
      if (this.outOfDateRange) return
      this.advancedSearch()
    },
    disableOutOfRangeDates(classes, date) {
      // Strikes out the days outside [start, start + 90] while the end date is being
      // picked; the library's td.disabled has pointer-events: none, so they can't be
      // clicked either. Done here rather than through the picker's minDate/maxDate
      // props because its clickRange() clamps every preset against those props, which
      // would cut "Last 90 days" down to a date the user had just clicked.
      if (this.minDate) {
        const day = this.moment(date)
        classes.disabled = day.format('YYYY-MM-DD') < this.minDate || day.isAfter(this.maxDate)
      }
      return classes
    },
    init() {
      clearTimeout(this.interval)
      if (this.type !== 'search' && (!this.quickSearchTerm || this.quickSearchTerm === '')) {
        this.setInterval()
      } else {
        clearTimeout(this.interval)
        if (this.$route.query.id) {
          this.advancedSearchTerm = this.$route.query.id
          this.advancedSearch()
        } else if (this.$route.query['id[]']) {
          this.advancedSearchTerm = this.$route.query['id[]'].join(',')
          clearTimeout(this.interval)
          this.initDatePicker()
          this.resetShippings()
          this.advancedSearch()
        } else if (this.$route.query.q) {
          this.advancedSearchFilters = JSON.parse(this.$route.query.q)
          clearTimeout(this.interval)
          this.initDatePicker()
          this.resetShippings()

          // Restore the form BEFORE fetching: outOfDateRange measures dateRange, so
          // while the fetch ran first the guard still saw the today-today default and
          // returned false, which is what let an oversized q search anyway.
          //
          // A q is untrusted input — hand-built links are this guard's threat model,
          // and one saved before the shipping-type filter existed carries fewer
          // entries. So every read below checks the shape it needs, not merely that
          // the index is there: a throw here now lands before the fetch AND before the
          // guard, which would leave a blank screen with nothing explaining it.
          // advancedSearchTerm must end up a string in particular — it is a text input
          // that buildAdvancedSearchFilters later .split(',')s. That method writes
          // filters[0] either as a positional [key, operator, term] triple (one term)
          // or as { value: [t1, t2] } (several).
          const restoredTerm = this.advancedSearchFilters[0]?.filters?.[0]
          if (Array.isArray(restoredTerm) && typeof restoredTerm[2] === 'string') {
            this.advancedSearchTerm = restoredTerm[2]
          } else if (Array.isArray(restoredTerm?.value)) {
            this.advancedSearchTerm = restoredTerm.value.join(',')
          } else if (typeof restoredTerm?.value === 'string') {
            this.advancedSearchTerm = restoredTerm.value
          }
          // Both of these back checkbox groups, so they have to stay arrays.
          const restoredType = this.advancedSearchFilters[3]?.filters?.[0]?.value
          if (Array.isArray(restoredType)) {
            this.advancedSearchType = restoredType
          }
          const restoredStatus = this.advancedSearchFilters[1]?.filters?.[0]?.value
          if (Array.isArray(restoredStatus)) {
            this.advancedSearchStatus = restoredStatus
          }
          // Both ends are required: a range needs two dates to be measured at all, and
          // restoring just one would show a range the link never asked for. Values that
          // are present but unparseable are left to moment — the resulting NaN span
          // reads as within the cap and the search runs, same as today; validating date
          // syntax is the API's job, not this UI guard's.
          const restoredFrom = this.advancedSearchFilters[2]?.filters?.[0]?.value
          const restoredTo = this.advancedSearchFilters[2]?.filters?.[1]?.value
          if (typeof restoredFrom === 'string' && typeof restoredTo === 'string') {
            this.dateRange.startDate = this.moment.utc(restoredFrom).tz(this.$tz)
            this.dateRange.endDate = this.moment.utc(restoredTo).tz(this.$tz)
            this.dateRangeActive = true
          }

          // Same cap, same measurement as the picker: one definition of the limit.
          // Vue 2 invalidates a computed synchronously on set, so this already sees
          // the range the link restored above.
          if (this.outOfDateRange) {
            this.restoredRangeBlocked = true
            // setInterval()'s 120s timer wakes up with updating = true and calls back
            // into init(); returning here would strand that flag, and the store skips
            // FETCH_START whenever it arrives, so the next real search would run with
            // no spinner.
            this.updating = false
            return
          }
          this.fetchShippings(this.listConfig)
        } else {
          clearTimeout(this.interval)
          this.initDatePicker()
          this.resetShippings()
        }
      }
    },
    bulkExportLabels() {
      this.generatingLabels = true
      const params = {
        shippings: this.labelableShippings
      }
      this.$http.post(this.$appConfig.api.baseUrl + 'shippings/labels', params)
        .then(response => {
          window.open(response.body.label, JSON.stringify(this.labelableShippings))
          this.generatingLabels = false
          // TODO: force download (needs CORS on S3 or API passthrough)
          // this.$http.get(response.body.label, {responseType: 'blob'})
          //   .then(response => {
          //     try {
          //       const url = window.URL.createObjectURL(new Blob([response.data]))
          //       const link = document.createElement('a')
          //       link.href = url
          //       link.setAttribute('download', this.url.replace(/~/g, '.').split('/')[(this.url.split('/').length - 1)])
          //       document.body.appendChild(link)
          //       link.click()
          //       link.remove()
          //       window.URL.revokeObjectURL(url)
          //       this.downloaded = true
          //     } catch (e) {
          //       this.error = true
          //       this.downloaded = true
          //     }
          //   })
        })
    },
    getPickedupShippings(id) {
      const params = {
        limit: 500,
        filter_groups: [
          {
            filters: [
              ['pickup_shipping_id', 'eq', id]
            ]
          }
        ]
      }
      this.pickedupShippingsParent = this.shippings.find(x => x.id === id)
      this.$http.get(this.$appConfig.api.baseUrl + 'users/' + this.$store.getters.profile.id + '/shippings', { params })
        .then(response => {
          this.pickedupShippings = response.body.data
        })
    },
    setInterval() {
      clearTimeout(this.interval)
      this.fetchShippings(this.listConfig)
      if (!this.quickSearchTerm || this.quickSearchTerm === '') {
        this.interval = setTimeout(function () {
          this.updating = true
          this.init()
        }.bind(this), 120000)
      }
    },
    clearInterval() {
      clearTimeout(this.interval)
    },
    initDatePicker() {
      this.locale = {
        direction: 'ltr',
        format: 'dd/mm/yyyy',
        separator: ' - ',
        applyLabel: this.$gettext('Apply'),
        cancelLabel: this.$gettext('Cancel'),
        weekLabel: 'W',
        customRangeLabel: 'Custom Range',
        daysOfWeek: this.moment.weekdaysMin(),
        monthNames: this.moment.monthsShort(),
        firstDay: this.moment().day(0) === this.moment().local().weekday(0) ? 0 : 1,
        showWeekNumbers: false
      }
      this.ranges = { //  default value for ranges object (if you set this to false ranges will no be rendered)
        [this.$gettext('Today')]: [this.moment().toDate(), this.moment().toDate()],
        [this.$gettext('Yesterday')]: [this.moment().subtract(1, 'days').toDate(), this.moment().subtract(1, 'days').toDate()],
        [this.$gettext('Last 7 days')]: [this.moment().subtract(6, 'day').startOf('day').toDate(), this.moment().subtract(0, 'day').endOf('day').toDate()],
        [this.$gettext('Last 30 days')]: [this.moment().subtract(29, 'day').startOf('day').toDate(), this.moment().subtract(0, 'day').endOf('day').toDate()],
        [this.$gettext('Last 60 days')]: [this.moment().subtract(59, 'day').startOf('day').toDate(), this.moment().subtract(0, 'day').endOf('day').toDate()],
        [this.$gettext('Last 90 days')]: [this.moment().subtract(89, 'day').startOf('day').toDate(), this.moment().subtract(0, 'day').endOf('day').toDate()],
        [this.$gettext('This month')]: [this.moment().startOf('month').toDate(), this.moment().endOf('month').toDate()],
        [this.$gettext('Last week')]: [this.moment().subtract(1, 'week').startOf('week').toDate(), this.moment().subtract(1, 'week').endOf('week').toDate()],
        [this.$gettext('Last month')]: [this.moment().subtract(1, 'month').startOf('month').toDate(), this.moment().subtract(1, 'month').endOf('month').toDate()]
      }
      this.datepickerLocalized = true
    },
    resetDateRange() {
      this.dateRange = {
        startDate: this.moment().toDate(),
        endDate: this.moment().toDate()
      }
      this.dateRangeActive = false
      this.minDate = null
      // Clearing the range must not hit the API: rebuild the filters so the now-empty
      // date filter reaches listConfig, then drop the results locally without fetching.
      this.buildAdvancedSearchFilters()
      this.resetShippings()
      // Deliberately no resetPagination() here: its currentPage assignment is watched,
      // and that watcher fetches. With the results cleared the paginator is gone anyway,
      // and the next advancedSearch() resets the page before fetching.
      // Strip a stale q so a reload cannot resurrect the range we just cleared —
      // buildAdvancedSearchFilters only rewrites q when one of these three is set.
      const [term, status, dates] = this.advancedSearchFilters
      if (!term.filters && !status.filters && !dates.filters) {
        const query = Object.assign({}, this.$route.query)
        delete query.q
        delete query.page
        this.$router.replace({ query })
      }
    },
    advancedSearch() {
      this.buildAdvancedSearchFilters()
      this.resetShippings()
      this.resetPagination()
      this.fetchShippings(this.listConfig)
    },
    buildAdvancedSearchFilters() {
      // Applying a search supersedes whatever the restored link asked for. Cleared
      // before touching currentPage so the watcher's guard cannot swallow the fetch.
      this.restoredRangeBlocked = false
      this.datepickerLocalized = false
      this.initDatePicker()
      this.isSearch = true
      this.currentPage = 1
      const query = Object.assign({}, this.$route.query)
      delete query.page
      this.$router.replace({ query })

      this.currentQuery = {}
      this.advancedSearchFilters = []
      if (this.advancedSearchTerm !== '') {
        const theSearchTerm = this.advancedSearchTerm.split(',')
        if (theSearchTerm.length === 1) {
          theSearchTerm[0] = theSearchTerm[0].trim()
          this.advancedSearchFilters[0] = {
            or: true,
            filters: [
              [(theSearchTerm[0].length <= 8) ? 'short_id' : 'id', 'eq', theSearchTerm[0]],
              {
                key: 'external_code',
                operator: 'eq',
                value: theSearchTerm[0]
              },
              {
                key: 'external_order_id',
                operator: 'eq',
                value: theSearchTerm[0]
              }
            ]
          }
        } else {
          this.advancedSearchFilters[0] = {
            filters: [
              {
                key: 'external_code',
                operator: 'in',
                value: theSearchTerm
              },
              {
                key: 'external_order_id',
                operator: 'ct',
                value: theSearchTerm
              }
            ]
          }
        }
      } else {
        this.advancedSearchFilters[0] = {}
      }

      if (this.advancedSearchStatus.length > 0) {
        this.advancedSearchFilters[1] = {
          filters: [{
            key: 'status',
            value: this.advancedSearchStatus,
            operator: 'in'
          }]
        }
      } else {
        this.advancedSearchFilters[1] = {}
      }
      if (this.advancedSearchType.length > 0) {
        this.advancedSearchFilters[3] = {
          filters: [{
            key: 'shipping_type_id',
            value: this.advancedSearchType,
            operator: 'in'
          }]
        }
      } else {
        this.advancedSearchFilters[3] = {}
      }
      console.log(this.dateRange)
      if (this.dateRangeActive) {
        console.log(this.dateRange.startDate)
        this.advancedSearchFilters[2] = {
          filters: [{
            key: 'created_at',
            value: this.moment(this.dateRange.startDate).tz(this.$tz).startOf('day').utc().format('YYYY-MM-DD HH:mm:ss'),
            operator: 'gte'
          },
          {
            key: 'created_at',
            value: this.moment(this.dateRange.endDate).tz(this.$tz).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss'),
            operator: 'lte'
          }]
        }
      } else {
        this.advancedSearchFilters[2] = {}
      }
      this.listConfig.filters.filter_groups = this.advancedSearchFilters

      if (this.advancedSearchFilters.length > 0 && (this.advancedSearchFilters[0].filters || this.advancedSearchFilters[1].filters || this.advancedSearchFilters[2].filters)) {
        this.$router.replace({ query: { q: JSON.stringify(this.advancedSearchFilters) } })
      }
    },
    clearAdvanceSearch() {
      // Does not go through buildAdvancedSearchFilters, so it clears the flag itself.
      this.restoredRangeBlocked = false
      this.advancedSearchTerm = ''
      this.advancedSearchStatus = []
      this.dateRange = {
        startDate: this.moment(),
        endDate: this.moment()
      }
      this.dateRangeActive = false
      this.advancedSearchFilters = []
      this.isSearch = false
      this.$router.push({ name: this.$route.name })
      this.resetShippings()
    },
    quickSearch() {
      if (this.quickSearchTerm) {
        this.isSearch = true
        this.searchFilters = {
          or: true,
          filters: [{
            key: 'to_contact',
            operator: 'ct',
            value: this.quickSearchTerm
          },
          {
            key: 'id',
            operator: 'ct',
            value: this.quickSearchTerm
          },
          {
            key: 'external_code',
            operator: 'ct',
            value: this.quickSearchTerm
          },
          {
            key: 'external_order_id',
            operator: 'ct',
            value: this.quickSearchTerm
          }]
        }
      } else {
        this.isSearch = false
        this.searchFilters = {}
      }
      this.listConfig.filters.filter_groups.push(this.searchFilters)
      console.log(this.quickSearchTerm)
      console.log(this.listConfig)
      this.resetPagination()
      this.fetchShippings(this.listConfig)
    },
    clearSearch() {
      // Same as clearAdvanceSearch, and this is also what the type watcher runs when
      // the user switches lists — the flag must not survive into another listing.
      this.restoredRangeBlocked = false
      this.advancedSearchTerm = ''
      this.advancedSearchStatus = []
      this.dateRange = {
        startDate: this.moment(),
        endDate: this.moment()
      }
      this.dateRangeActive = false
      this.advancedSearchFilters = []
      this.quickSearchTerm = ''
      this.isSearch = false
      this.searchFilters = {}
      this.$router.push({ name: this.$route.name })
      this.quickSearch()
    },
    resetShippings() {
      this.$store.dispatch(RESET_SHIPPINGS, this.listConfig)
    },
    fetchShippings(listConfig = null) {
      // Single chokepoint for the restored-range guard. init() returning early is not
      // enough on its own: switching lists runs clearSearch(), whose quickSearchTerm
      // reset fires its watcher on the next tick, and that calls setInterval(), which
      // fetches unconditionally — putting the range init() just refused on the wire.
      if (this.restoredRangeBlocked) return
      let query = {}
      if (this.advancedSearchFilters.length > 0 && (this.advancedSearchFilters[0].filters || this.advancedSearchFilters[1].filters || this.advancedSearchFilters[2].filters)) {
        query = {
          q: JSON.stringify(this.advancedSearchFilters)
        }
      }
      console.log(this.listConfig)
      this.currentQuery = query
      this.$store.dispatch(FETCH_SHIPPINGS, listConfig || this.listConfig).then(() => {
        this.updating = false

        if (this.newSearch) {
          this.$refs.paginator.changePage(1)
          this.newSearch = false
        }
      })
    },
    resetPagination() {
      this.listConfig.offset = 0
      this.currentPage = 1
      const query = Object.assign({}, this.$route.query)
      delete query.page
      this.$router.replace({ query })
    },
    setList(filter) {
      this.type = filter
    },
    downloadCsv() {
      const reportConfig = { ...this.listConfig }
      reportConfig.filters.simplified = this.simplifiedReport
      reportConfig.filters.statuses_history = this.allStatuses
      reportConfig.filters.format = 'upload'
      reportConfig.filters.sort = [{
        key: 'created_at',
        direction: 'desc'
      }]
      this.$http.get(this.$appConfig.api.baseUrl + 'users/' + this.$store.getters.profile.id + '/shippings', { params: reportConfig.filters })
        .then(response => {
          const obj = {
            title: this.$gettext('JOB DISPATCHED'),
            message: this.$gettext('The CSV Report is being generated, you will receive an email with a link to download it as soon as it\'s done'),
            type: 'success',
            customCloseBtnText: this.$gettext('Close')
          }
          this.$root.$children[0].$refs.simplert.openSimplert(obj)
        })
    },
    bulkChangeStatusToReady() {
      if (confirm(this.$gettextInterpolate(this.$gettext('Are the shippings READY TO BE PICKED UP by our %{courierI18n}?'), { courierI18n: this.courierI18n })) === true) {
        this.shippingsEnabledToReady.forEach(shippingId => {
          const params = {}
          if (this.profile.company && this.profile.company.settings.findIndex(x => x.name === 'via_warehouse') !== -1 && this.profile.company.settings.find(x => x.name === 'via_warehouse').pivot.value === '1') {
            params.status = 'READYATSTORE'
          } else {
            params.status = 'READY'
          }
          this.$http.post(this.$appConfig.api.baseUrl + 'shippings/' + shippingId + '/status', params)
        })
      }
    }
  }
}
</script>

<style lang="scss">
.daterangepicker .drp-buttons .btn {
  font-size: inherit !important;
  padding: 0.5rem 1.75rem !important;
  font-weight: normal !important;
}
</style>
